<mat-sidenav-container>
  <div id="main-content">
    <lin-header-banner *ngIf="showBanner"></lin-header-banner>
    <div id="wrapper">
      <!-- // TODO: need to update -->
      <ng-container *ngIf="authService.isLoggedIn$ | async">
        <ng-container *ngIf="authService.termsAccepted$ | async">
          <div class="header-logo">
            <img alt="logo" class="logo-icon" [src]="(platformSettings$ | async)?.logoUrl" />
          </div>
          <lin-sidebar [folded]="false" [lockedOpen]="'gt-md'" class="left-navbar">
            <lin-navbar></lin-navbar>
          </lin-sidebar>
        </ng-container>
      </ng-container>

      <div class="content-wrapper">
        <ng-container *ngIf="authService.isLoggedIn$ | async">
          <ng-container *ngIf="authService.termsAccepted$ | async">
            <button mat-button class="toggle-button-navbar mat-icon-button" (click)="toggleSidebar()" fxShow fxHide.gt-md="true">
              <mat-icon svgIcon="menu"></mat-icon>
            </button>
            <lin-toolbar class="above"></lin-toolbar>
          </ng-container>
        </ng-container>
        <lin-content></lin-content>
      </div>
    </div>
  </div>
</mat-sidenav-container>
